import React from "react";
import DataGrid from "../../app/grid/DataGrid";
import { TReportingPeriodFormTypePresentationModel } from "../../../../model/form/mappers/ReportingPeriodFormTypeListMapper";
import FormVersionsGrid from "./FormVersionsGrid";
import { TBoFormVersionPresentationModel } from "../../../../presenter/applicants/model/BoFormVersionPresentationModel";
import { Spin } from "antd";
import { TApplicantReportingPeriodPresentationModel } from "../../../../presenter/applicants/model/ApplicantReportingPeriodPresentationModel";
import { IRegisteredApplicant } from "../../../../model/applicant/RegisteredApplicant";
import { TGridAction } from "../../app/grid/GridActionsDropdown";
import { StatusForm } from "../../../../common/Constants";
import { IConfiguration } from "../../../../model/config/Configuration";

export interface Props {
  formTypes: TReportingPeriodFormTypePresentationModel[];
  translate: any;
  formVersions: TBoFormVersionPresentationModel[];
  onExpandFormType: any;
  onExpandFormVersion?: any;
  formVersionsLoader?: boolean;
  childrenLoader?: boolean;
  children: any;
  reportingPeriod?: TApplicantReportingPeriodPresentationModel;
  onChangeModalVisible?: any;
  applicant?: IRegisteredApplicant;
  addNewDraftFormVersion?: any;
  isApplicantForms?: boolean;
  isApplicantEvaluations?: boolean;
  parentExpand?: boolean;
  configuration: IConfiguration;
}

export interface State {}

export default class FormTypesGrid extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      formTypes,
      translate,
      formVersions,
      onExpandFormType,
      formVersionsLoader,
      onExpandFormVersion,
      childrenLoader,
      children,
      reportingPeriod,
      onChangeModalVisible,
      applicant,
      addNewDraftFormVersion,
      isApplicantForms,
      isApplicantEvaluations,
      parentExpand,
      configuration
    } = this.props;

    const columns = [
      {
        title: translate("reports_page.form_types_datagrid.columns.form_name"),
        dataIndex: "formName",
        key: "formName"
      },
      {
        title: translate(
          "reports_page.form_types_datagrid.columns.current_version"
        ),
        dataIndex: "currentVersion",
        key: "currentVersion"
      },
      {
        title: translate("reports_page.form_types_datagrid.columns.status"),
        dataIndex: "status",
        key: "status"
      },
      {
        title: translate(
          "reports_page.form_types_datagrid.columns.date_of_last_change"
        ),
        dataIndex: "dateOfLastChange",
        key: "dateOfLastChange",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(
            a.dateOfLastChange,
            b.dateOfLastChange
          )
      },
      {
        title: translate("reports_page.form_types_datagrid.columns.send_date"),
        dataIndex: "sendDate",
        key: "sendDate",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.sendDate, b.sendDate)
      }
    ];

    const checkDraftFormVersion = () => {
      return formTypes.find((formType) => formType.status === StatusForm.DRAFT);
    };

    const expandedRowRender = (record, index, indent, expanded) => {
      return (
        <Spin spinning={formVersionsLoader ? true : false}>
          <FormVersionsGrid
            translate={translate}
            formVersions={formVersions}
            onExpandFormVersion={onExpandFormVersion}
            childrenLoader={childrenLoader}
            children={children}
            reportingPeriod={reportingPeriod}
            formType={record}
            onChangeModalVisible={onChangeModalVisible}
            applicant={applicant}
            isApplicantForms={isApplicantForms}
            isApplicantEvaluations={isApplicantEvaluations}
            parentExpand={expanded}
            configuration={configuration}
          />
        </Spin>
      );
    };

    const actions: TGridAction[] = [
      {
        label: translate("applicantForms_page.add_new_version"),
        type: "default",
        loading: (record) => record.addNewDraftVersionLoader || false,
        onClick: (record) => (e) =>
          addNewDraftFormVersion(record.id, reportingPeriod?.id, applicant?.id)
      }
    ];

    return (
      <DataGrid
        translate={translate}
        columns={columns}
        dataSource={formTypes}
        expandedRowRender={expandedRowRender}
        singleRowExpandEnabled={true}
        onExpand={onExpandFormType}
        actions={
          reportingPeriod?.hasRightOfEntry && !checkDraftFormVersion()
            ? actions
            : []
        }
        horizontalScroll={false}
        expandedRowKeyList={!parentExpand ? [] : undefined}
      />
    );
  }
}
